import View     from 'scripts/poppet/view';
import template from 'scripts/defa/role-applications/template-role-application-view.jst.html';
import { T }    from 'defa-object';


const selectors = {
	rejectButton : '[data-click=application-reject]',
	approveButton: '[data-click=application-approve]',
};

const channelLayout = Bb.Radio.channel ( 'layout' );

const RoleApplicationView = View.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	template: template,
	ui      : {
		reject : selectors.rejectButton,
		approve: selectors.approveButton,
	},
	
	events: {
		'click @ui.reject' : 'onClickReject',
		'click @ui.approve': 'onClickApprove',
	},
	
	templateContext: function () {
		return {
			address1     : this.model.get( 'customer' ).address1 || '',
			address2     : this.model.get( 'customer' ).address2 || '',
			companyName  : this.model.get( 'customer' ).companyName || '',
			companyNumber: this.model.get( 'customer' ).companyNumber || '',
			contactEmail : this.model.get( 'customer' ).contactEmail || '',
			country      : this.model.get( 'customer' ).country || '',
			phoneNumber  : this.model.get( 'phoneNumber' ).phoneNumber || '',
			postcode     : this.model.get( 'customer' ).postcode || '',
			roles        : this.model.get('customer').roles || '',
			city         : this.model.get( 'customer' ).city || '',
			isEmobility  : this.model.get('customer').isRoleApplicationEmobilityOnly,
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a user clicks the reject button.
	 * @void
	 */
	onClickReject: function () {
		let self = this;
		this.busy();
		this.model._reject( {
			success: function ( options ) {
				self.idle();
				self._showSuccessView( options );
			},
			error  : function ( options ) {
				self.idle();
				self._showErrorView( options );
			}
		} );
	},
	
	/**
	 * Triggers when a user clicks the approve button.
	 * @void
	 */
	onClickApprove: function () {
		let self = this;
		this.busy();
		this.model._approve( {
			success: function ( options ) {
				self.idle();
				self._showSuccessView( options );
			},
			error  : function ( options ) {
				self.idle();
				self._showErrorView( options );
			}
		} );
	},
	
	// ------------------------------------------------
	// Other Functions
	// ------------------------------------------------
	/**
	 * Showing a success view.
	 * @param  {object} options  The options for the successView.
	 * @void
	 */
	_showSuccessView: function(options){
		options.context = 'application:reviewed';
		options.closeLink = this.options.closeLink;
		channelLayout.trigger( 'success' , options);
	},
	
	/**
	 * Showing an error view.
	 * @param  {object} options  The options for the errorView.
	 * @void
	 */
	_showErrorView: function(options){
		options.closeLink = this.options.closeLink;
		channelLayout.trigger( 'error', options);
	},
} );

export default RoleApplicationView;